var lib_core = require("lib-core");

var Editor3dController = require("../extensions/editor3d/editor3dController.js");

var Abstract3dViewerController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(Abstract3dViewerController, lib_core.Controller);
Abstract3dViewerController.inject = {
    editorController : Editor3dController
};
module.exports = Abstract3dViewerController;

Abstract3dViewerController.prototype.beforeLoad = function() {
    var self = this;

    lib_core.Controller.prototype.beforeLoad.call(this);

    if(this.getDataType() instanceof Array){
        var dataArr = this.getDataType();
        for(var i = 0; i < dataArr.length; i++){
            this.register(dataArr[i]);
        }
    } else {
        this.register(this.getDataType());
    }

};

Abstract3dViewerController.prototype.register = function(data){
    var self = this;

    if(!this.configuration.collection_configs) {
        this.editorController.registerDataModelView(data,
            this.getViewCollection(), this.getInteractionModelType(),
            this.getInteractionViewType(), this.configuration.layers, this.configuration.IMOptions);
    } else {
        this.configuration.collection_configs.forEach(function (collection_config) {
            self.editorController.registerDataModelView(data,
                self.getViewCollection(collection_config.collection), self.getInteractionModelType(),
                self.getInteractionViewType(), collection_config.layers, collection_config.IMOptions);
        });
    }
}

Abstract3dViewerController.prototype.getDataType = function () {
    // has to be implemented by child classes
    console.error("Not implemented");
};

Abstract3dViewerController.prototype.getInteractionModelType = function () {
    // has to be implemented by child classes
    console.error("Not implemented");
};

Abstract3dViewerController.prototype.getInteractionViewType = function () {
    // has to be implemented by child classes
    console.error("Not implemented");
};


Abstract3dViewerController.prototype.getViewCollection = function (collection) {
    if(collection) {
        return this.root.findByPath(collection);
    } else if(this.configuration.collection) {
        return this.root.findByPath(this.configuration.collection);
    } else if(this.parent()) {
        return this.parent().getViewCollection();
    } else return null;
};


